import { InjectionToken } from '@angular/core';

export interface MuiModuleConfig {
  homeUrl: string;
  useHrefForHomeLinks: boolean;
}

/**
 * The configuration options used inside the Module for routing, redirection & scrollBar options.
 * 'homeUrl' and 'useHrefForHomeLinks' will be used in the Header logo anchor and
 * in the root Breadcrumb.
 */
export const MUI_APP_CONFIG = new InjectionToken<MuiModuleConfig>('MUI_APP_CONFIG', {
  providedIn: 'root',
  factory: (): MuiModuleConfig => ({
    homeUrl: '/',
    useHrefForHomeLinks: false
  })
});
